module.exports = __webpack_public_path__ + "img/dice-d4.60521930.svg";